/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
import { orderBy } from 'lodash';
import { useQuery, useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { GET_FILES_RELATIONSHIP } from 'Apollo/Queries/DataRecon/DataRelationship';
import {
    GET_FILES_FOR_PROJECT, GET_RECON_FUNCTIONS, GET_FILTER_FUNCTIONS, GET_PROJECT_CONFIGURATION,
} from 'Apollo/Queries/DataRecon/DataConfiguration';
import {
    activeDataReconMenuVar, showDataReconMenusVar, leftNavigationItemsVar, currentLeftMenuVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import crossReportImg from 'assets/images/cross-report-black.svg';
import DataRelationship from '../components';

let id = 0;
const getId = () => {
    const nodeId = `dndnode_${id}`;
    id += 1;
    return nodeId;
};

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const getWeightage = (sourceColMatch, targetColMatch) => {
    if (sourceColMatch) {
        return sourceColMatch.colMatchPercent;
    }
    return targetColMatch ? targetColMatch.colMatchPercent : 0;
};

const getSelectedCols = (selectedNode, colsData) => {
    if (selectedNode.type === 'input') {
        return colsData.filter(c => c.id === selectedNode.id)[0].columns.filter(item => item.isChecked);
    }
    return selectedNode.selectedColumns;
};

const getNewNode = (type, position, nodeId, nodeData) => ({
    type,
    position,
    id: nodeId,
    data: {
        label: `${nodeData.fileDisplayName || nodeData.functionName.charAt(0).toUpperCase() + nodeData.functionName.slice(1)}`,
        fileName: nodeData.fileName,
        type: nodeData.functionName ? nodeData.functionName : '',
        projectId: nodeData.projectId ? nodeData.projectId : '',
        parentProjectId: nodeData.projectDisplayId ? nodeData.projectDisplayId.split('.')[0] : '',
        fileId: nodeData.fileId ? nodeData.fileId : null,
    },
});

const getColsData = (nodeId, nodeData, filterFunctions, colMatchData) => ({
    id: nodeId,
    columns: nodeData.columnDetails ? nodeData.columnDetails.map(col => {
        // get weightage for each column from columnMatchData
        const srcColMatch = colMatchData.find(cm => cm.sourceCol === col.name);
        const trgtColMatch = colMatchData.find(cm => cm.targetCol === col.name);
        const baseObj = {
            column: col.name,
            dataType: col.dataType,
            isChecked: true,
            filters: filterFunctions && filterFunctions.length > 0 && filterFunctions.map(fl => ({
                ...fl,
                displayName: fl.functionName.charAt(0).toUpperCase() + fl.functionName.slice(1),
                isSelected: false,
            })),
            operation: '',
            weightage: getWeightage(srcColMatch, trgtColMatch),
        };
        if (col.dataType === 'date') {
            baseObj.start_date = '';
            baseObj.end_date = '';
        } else {
            baseObj.transformation = '';
        }
        return baseObj;
    }) : [],
    allChecked: true,
});

const getFileData = (sourceNodes, colsData) => sourceNodes && sourceNodes.map(sc => {
    const selCols = getSelectedCols(sc, colsData);
    const orderedSelCols = orderBy(selCols, ['weightage'], ['desc']);
    return {
        ...sc,
        id: sc.id,
        fileId: sc?.data?.fileId,
        fileName: sc.data.fileName || sc.fileName,
        selectedColumns: orderedSelCols,
        fileDisplayName: sc.type !== 'default' ? sc.data.label : `${sc.data.label}_result.csv`,
        isSubProject: sc.type === 'special',
    };
});

const getFileDataForSum = updatedFileData => updatedFileData && updatedFileData.map(c => ({
    ...c,
    selectedColumns: c.selectedColumns.map(sc => ({
        ...sc,
        isSourceColumn: false,
        isTargetColumn: false,
        isSourceGroupBy: false,
        isTargetGroupBy: false,
        displayName: sc.column,
    })),
}));

const getTableArray = columnData => columnData?.source_col.map((_, index) => ({
    sourceCol: columnData.source_col[index],
    dataTypeSrc: columnData.data_type_1[index],
    targetCol: columnData.target_col[index],
    dataTypeTrgt: columnData.data_type_2[index],
    colMatchPercent: columnData.col_match_percent && columnData.col_match_percent[index],
}));

/* function to create new edge */
const createEdge = (sourceNode, reconNode) => ({
    id: `reactflow__edge-${sourceNode.id}null-${reconNode.id}null`,
    source: sourceNode.id,
    target: reconNode.id,
    type: 'default',
    sourceHandle: null,
    targetHandle: null,
});

/* function to create new node */
const createNode = (position, type, data) => {
    const nodeId = getId();
    return getNewNode(type, position, nodeId, data);
};

/* function to create flow */
const createFlow = (filesDetails, selectedRelation, functions, selectedOperation, filterFunctions, colMatchData) => {
    let colsData = [];
    let sourceNodes = [];
    let elements = [];
    const sourceFileInfo = filesDetails.find(f => f.fileName === selectedRelation.sourceFileName);
    const targetFileInfo = filesDetails.find(f => f.fileName === selectedRelation.targetFileName);
    const reconInfo = functions.find(f => f.functionName === selectedOperation.toLowerCase());
    const sourceNode1 = createNode({ x: 80, y: 45 }, 'input', sourceFileInfo);
    colsData = colsData.concat(getColsData(sourceNode1.id, sourceFileInfo, filterFunctions, colMatchData));
    sourceNodes = sourceNodes.concat(sourceNode1);
    elements = elements.concat(sourceNode1);
    const sourceNode2 = createNode({ x: 300, y: 45 }, 'input', targetFileInfo);
    colsData = colsData.concat(getColsData(sourceNode2.id, targetFileInfo, filterFunctions, colMatchData));
    sourceNodes = sourceNodes.concat(sourceNode2);
    elements = elements.concat(sourceNode2);
    const reconNode = createNode({ x: 200, y: 180 }, 'default', reconInfo);
    elements = elements.concat(reconNode);
    colsData = colsData.concat(getColsData(sourceNode1.nodeId, sourceFileInfo, filterFunctions, colMatchData));
    elements = elements.concat(createEdge(sourceNode1, reconNode));
    elements = elements.concat(createEdge(sourceNode2, reconNode));

    return {
        nodeElements: elements,
        columnsData: colsData,
        srcNodes: sourceNodes,
        nodeId: reconNode.id,
    };
};

const DataRelationshipContainer = () => {
    const history = useHistory();
    const location = useLocation();
    const [tenantId, setTenantId] = useState(location.state.tenantId);
    const [projectId, setProjectId] = useState(location.state.projectId);
    const [project, setProject] = useState(location.state.project);
    const [elements, setElements] = useState([]);
    const [reconNodeId, setReconNodeId] = useState('');
    const [fileRelationData, setFileRelationData] = useState([]);
    const [showSuggestionModal, setShowSuggestionModal] = useState(false);
    const [selectedRelation, setSelectedRelation] = useState(null);
    const [selectedOperation, setSelectedOperation] = useState('Sum');
    const [filesDetails, setFilesDetails] = useState(null);
    const [functions, setFunctions] = useState(null);
    const [filterFunctions, setFilterFunctions] = useState(null);
    const [colsData, setColsData] = useState([]);
    const [diagramFlow, setDiagramFlow] = useState(null);
    const [sourceNodes, setSourceNodes] = useState([]);
    const [configData, setConfigData] = useState([]);
    const [flowConfig, setFlowConfig] = useState(null);
    const [isConfigBuilding, setIsConfigBuilding] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [colMatchData, setColMatchData] = useState([]);
    /* apollo query to fetch relationships between files */
    const { loading, data: fileRelationsData } = useQuery(GET_FILES_RELATIONSHIP, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                projectId: parseInt(projectId, 10),
            },
        },
    });
    /* apollo query to fetch existing project configuration */
    const projectConfig = useQuery(GET_PROJECT_CONFIGURATION, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 10,
                pageNumber: 1,
                projectId: Number(projectId),
            },
        },
    });
    /* apollo query to fetch all files of selected project */
    const [getFilesDetails, {
        data: fileDetailsData,
    }] = useLazyQuery(GET_FILES_FOR_PROJECT, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                projectId,
                pageSize: 8,
                pageNumber: 1,
                tenantId,
            },
        },
    });
    /* apollo query to fetch all recon functions of selected project */
    const [getReconFunctions, { data: reconFunctionData }] = useLazyQuery(GET_RECON_FUNCTIONS, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 10,
                pageNumber: 1,
                isPreview: false,
            },
        },
    });
    /* apollo query to fetch all filter functions of selected project */
    const [getFilteredFunctions, { data: filterFunctionData }] = useLazyQuery(GET_FILTER_FUNCTIONS, {
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                pageSize: 15,
                pageNumber: 1,
                isPreview: true,
            },
        },
    });
    /* function called when navigating to configuration page */
    const navigateToConfigPage = value => {
        if (value === true) {
            diagramFlow.elements = [{ ...diagramFlow.elements[0] }, { ...diagramFlow.elements[1] }];
        }
        history.push(
            {
                pathname: '/dataconfiguration',
                state: {
                    projectId,
                    tenantId,
                    project,
                    diagramFlow,
                    flowConfig: value === true ? {} : flowConfig,
                    selectedColumnsData: colsData,
                },
            },
        );
    };
    /* function to navigate to projects component */
    const navigateToProjects = () => history.push({
        pathname: '/projects',
        state: { tenantId },
    });
    /* function to navigate to Data Recon home page */
    const navigateToReconHome = () => history.push(
        {
            pathname: '/data-recon-home',
            state: { tenantId },
        },
    );
    /* function to navigate to file upload page/ project details page */
    const navigateToDataLineageUpload = () => history.push({
        pathname: '/data-lineage-upload',
        state: { tenantId, project },
    });
    /* callback function called when Select is clicked from Card */
    const onSelect = selectedSuggesstion => {
        setSelectedRelation(selectedSuggesstion);
        setColMatchData(getTableArray(selectedSuggesstion.columnMatch));
    };
    const onShowDetails = columnData => {
        setColMatchData(getTableArray(columnData));
        setShowDetailsModal(true);
    };
    // Breadcrumbs items
    const items = [
        {
            link: '',
            value: <span className="appkiticon icon-home-fill font-16" onClick={navigateToReconHome} role="presentation" />,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text" onClick={navigateToProjects} role="presentation"> Projects </span>,
        },
        {
            link: '',
            value: (
                <span
                    className="a-breadcrumb-item-text"
                    onClick={navigateToDataLineageUpload}
                    role="presentation"
                >
                    {project?.projectName}
                </span>
            ),
        },
        {
            link: '',
            value: <span className="a-h6">Predicted Relationship</span>,
        },
    ];
    /* side effect called when component loads */
    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.DATARECONCILIATION);
    }, []);
    /* side effect when location is changed */
    useEffect(() => {
        setProjectId(location.state.projectId);
        setTenantId(location.state.tenantId);
        setProject(location.state.project);
        showDataReconMenusVar(true);
        activeDataReconMenuVar('projects');
    }, [location]);
    /* side effect when projectId is changed */
    useEffect(() => {
        Promise.all([getFilesDetails(), getReconFunctions(), getFilteredFunctions()]);
    }, [projectId]);
    /* side effect when fileDetailsData, reconFunctionData and filterFunctionData
       is changed
    */
    useEffect(() => {
        const isFileDetailsAvailable = fileDetailsData && fileDetailsData.getFilesForProject.length > 0;
        const isReconFunctionsAvailable = reconFunctionData && reconFunctionData.getReconFunctions.length > 0;
        const isFilterFunctionsAvailable = filterFunctionData && filterFunctionData.getReconFunctions.length > 0;

        if (isFileDetailsAvailable && isReconFunctionsAvailable && isFilterFunctionsAvailable) {
            setFilesDetails(fileDetailsData.getFilesForProject);
            setFunctions(reconFunctionData.getReconFunctions);
            setFilterFunctions(filterFunctionData.getReconFunctions);
        }
    }, [fileDetailsData, reconFunctionData, filterFunctionData]);
    /* side effect when fileRelationsData is changed */
    useEffect(() => {
        if (fileRelationsData && fileRelationsData.findDataSetRelation) {
            setFileRelationData(fileRelationsData.findDataSetRelation);
        }
    }, [fileRelationsData]);
    /* side effect when showSuggestionModal is changed to false
    reset elements, colsData, diagramFlow, configData, selectedRelation, sourceNodes.
    Note: This side effect will happen when user close or cancel the modal. That means user selection has been reset. */
    useEffect(() => {
        if (showSuggestionModal === false) {
            setSelectedRelation(null);
            setSourceNodes([]);
            setElements([]);
            setColsData([]);
            setDiagramFlow([]);
            setConfigData([]);
            setReconNodeId(null);
            setColMatchData([]);
        }
    }, [showSuggestionModal]);
    /* side effect when colMatchData, selectedRelation and filesDetails is changed */
    useEffect(() => {
        const isColMatchDataAvailable = colMatchData && colMatchData.length > 0;
        const isFileDetailsAvailable = filesDetails && filesDetails.length > 0;
        if (selectedRelation && isColMatchDataAvailable && isFileDetailsAvailable) {
            const {
                nodeElements, columnsData, srcNodes, nodeId,
            } = createFlow(filesDetails, selectedRelation, functions, selectedOperation, filterFunctions, colMatchData);
            setElements(nodeElements);
            setColsData(columnsData);
            setSourceNodes(srcNodes);
            setReconNodeId(nodeId);
        }
    }, [selectedRelation, colMatchData, filesDetails]);
    /* side effect when elements is changed and to set flow diagram */
    useEffect(() => {
        const maxElementsArrayLength = 5;
        if (elements && elements.length === maxElementsArrayLength) {
            const flow = { elements, position: [0, 0], zoom: 1 };
            setDiagramFlow(flow);
        }
    }, [elements]);
    /* side effect when diagramFlow is changed, set config data and set
    showSuggestionModal to true */
    useEffect(() => {
        if (diagramFlow && Object.keys(diagramFlow).length > 0) {
            let updatedFileData = getFileData(sourceNodes, colsData);
            if (selectedOperation === 'Sum') {
                updatedFileData = getFileDataForSum(updatedFileData);
            }
            setConfigData(updatedFileData);
            setShowSuggestionModal(true);
        }
    }, [diagramFlow]);
    return (
        <DataRelationship
            breadcrumbItems={items}
            navigateBack={navigateToDataLineageUpload}
            fileRelationData={fileRelationData}
            elements={elements}
            loading={loading}
            onSelect={onSelect}
            showSuggestionModal={showSuggestionModal}
            setShowSuggestionModal={setShowSuggestionModal}
            selectedOperation={selectedOperation}
            setSelectedOperation={setSelectedOperation}
            colsData={colsData}
            configData={configData}
            reconNodeId={reconNodeId}
            flowConfig={flowConfig}
            setFlowConfig={setFlowConfig}
            isConfigBuilding={isConfigBuilding}
            setIsConfigBuilding={setIsConfigBuilding}
            showDetailsModal={showDetailsModal}
            setShowDetailsModal={setShowDetailsModal}
            onShowDetails={onShowDetails}
            selectedRelation={selectedRelation}
            colMatchData={colMatchData}
            navigateToConfigPage={navigateToConfigPage}
            projectId={projectId}
            projectConfig={projectConfig}
        />
    );
};

export default DataRelationshipContainer;
